import Enllac from 'components/corporatiu/Enllac';
import Imatge from 'components/corporatiu/Imatge/Imatge';
import clsx from 'clsx';
import __isEmpty from 'lodash/isEmpty';
import styles from './destacatPoster.module.scss';

const DestacatPoster = (props) => {
    const {
        item,
        routePath,
        portal,
        className,
        testId,
        mostrarImatge,
        disposicio,
        retallarEntradeta = false,
        estil,
        tema,
        tipusImatge = 'web_poster_vertical',
        numColumnsRow = 12,
        icona = 'auto',
        mostrarLink = true
    } = props;

    const { id, titol, imatges, videos, audios, domini, tipologia, url } = item || props;

    const route = {
        type: routePath,
        slug: titol,
        id: id,
        domini: domini,
        tipologia: tipologia,
        href: url
    };

    const stylesDestacat = clsx({
        [styles.destacatBasic]: true,
        [styles.retallarEntradeta]: retallarEntradeta,
        [styles[portal]]: !__isEmpty(portal),
        [styles[estil]]: !__isEmpty(estil),
        [styles[tema]]: !__isEmpty(tema),
        [className]: !__isEmpty(className),
        [styles.horitzontal]: disposicio === 'horitzontal'
    });

    if (!titol) {
        return <></>;
    }

    const ConditionalEnllac = mostrarLink
        ? ({ children, ...rest }) => <Enllac {...rest}>{children}</Enllac>
        : ({ children }) => <>{children}</>;

    let iconType = null;
    if (icona !== 'no') {
        if ((icona === 'auto' && videos) || icona === 'video') {
            iconType = 'play';
        } else if ((icona === 'auto' && audios) || icona === 'audio') {
            iconType = 'auriculars_ple';
        }
    }

    return (
        <div key={`destacat-basic-${id}`} className={stylesDestacat} {...(testId && { 'data-testid': testId })}>
            {mostrarImatge && imatges && (
                <ConditionalEnllac route={route} dataTestId='destacat-enllac' className={styles.enllac}>
                    <div className={styles.imatgeWrapper}>
                        <Imatge
                            imatges={imatges}
                            className={styles.imatge}
                            tipus={tipusImatge}
                            numColumnsRow={numColumnsRow}
                            aria-hidden='true'
                            layout='fill'
                            priority={false}
                            data_testid='destacat-img'
                        />
                    </div>
                </ConditionalEnllac>
            )}
        </div>
    );
};

export default DestacatPoster;
